import { useCallback, useContext } from 'react';

import AccountContext from 'contexts/AccountContext';
import { AccountTodayOverrideContext } from 'contextProviders/SplashScreenProviders/UserAndAccountProviders/AccountTodayOverrideProvider';
import { FiscalPeriodsContext } from 'contextProviders/SplashScreenProviders/UserAndAccountProviders/FiscalPeriodsProvider';
import buildDateRange from 'hooks/useDateScope/buildDateRange';

/**
 * Resolves a leaderboard range (relative / fixed / advanced + date field) to a
 * search2 dateScope. Pure buildDateRange against the account's calendar — no
 * ambient date context needed, so it works on the slide and in its form.
 */
const useBuildLeaderboardDateScope = () => {
  const { weekStartsOn, timezone } = useContext(AccountContext);
  const { todayOverride } = useContext(AccountTodayOverrideContext);
  const { allFiscals } = useContext(FiscalPeriodsContext);

  return useCallback(
    ({
      relativeDateRange,
      dateRange,
      advancedRelativeDateRange,
      dateField,
    }: {
      relativeDateRange?: RelativeDateRange;
      dateRange?: DateRangeInput;
      advancedRelativeDateRange?: AdvancedRelativeDateRange;
      dateField?: string;
    }): DateRangeInput => ({
      ...buildDateRange({
        relativeDateRange,
        dateRange,
        advancedRelativeDateRange,
        weekStartsOn,
        periods: [],
        timezone,
        todayOverride,
        allFiscals,
      }),
      dateField,
    }),
    [weekStartsOn, timezone, todayOverride, allFiscals],
  );
};

export default useBuildLeaderboardDateScope;
